// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
  border-radius: 0px !important;
}

.popup-content {
  background-color: var(--gray-color) !important;
  border-radius: 5px !important;
}

.btn-share {
  border-radius: 0px 7px 7px 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/UsersPanel/NewUserModal/NewUserModal.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;AACJ;;AAEA;EACI,8CAAA;EACA,6BAAA;AACJ;;AAEA;EACI,yCAAA;AACJ","sourcesContent":["input {\n    border-radius: 0px  !important;\n}\n\n.popup-content{\n    background-color: var(--gray-color) !important;\n    border-radius: 5px !important;\n}\n\n.btn-share {\n    border-radius: 0px 7px 7px 0px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
